import { HomePageHandler } from './Home';
import { Utils } from './Utils';
import { AboutPageHandler } from './About';
import { ContactPageHandler } from './Contact';
import { CustomPageHandler } from './Custom';
import { CustomNewPageHandler } from './CustomNew';
import { MenuHandler } from './Menu';
import { AjaxPageHandler } from './Ajax';
import jQuery from "jquery";
import InitMap from './InitMap';
import { ScrollSmoother } from "gsap/ScrollSmoother";


import { gsap } from 'gsap';
import { imagesLoaded } from 'imagesloaded';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';



class GlobalHandler {
	constructor() {
		this.pageHandlers = [
			{ name: 'homePageHandler', class: HomePageHandler, id: 'homepage' },
			{ name: 'aboutPageHandler', class: AboutPageHandler, id: 'about-us' },
			{ name: 'contactPageHandler', class: ContactPageHandler, id: 'contact-us' },
			{ name: 'customPageHandler', class: CustomPageHandler, id: 'custom-work' },
			{ name: 'customNewPageHandler', class: CustomNewPageHandler, id: 'custom-work-new' },
			{ name: 'lookbooksPageHandler', class: CustomPageHandler, id: 'lookbooks' },
			{ name: 'gdprPageHandler', class: CustomPageHandler, id: 'gdpr' },
			{ name: 'termsofusePageHandler', class: CustomPageHandler, id: 'terms-of-use' },
			{ name: 'privacyPageHandler', class: CustomPageHandler, id: 'privacy-policy' },
			{ name: 'cookiesPageHandler', class: CustomPageHandler, id: 'cookies' },
			{ name: 'successPageHandler', class: CustomPageHandler, id: 'success' },
			{ name: 'unsubscribedPageHandler', class: CustomPageHandler, id: 'unsubscribed' },
			{ name: 'thank-youPageHandler', class: CustomPageHandler, id: 'thank-you' },
			{ name: 'manage-subscriptionPageHandler', class: CustomPageHandler, id: 'manage-subscription' },
			{ name: 'blogPageHandler', class: CustomPageHandler, id: 'blog' },
			{ name: 'blogPostPageHandler', class: CustomPageHandler, id: 'single-post' },
			/* English */
			{ name: 'lookbooksEnPageHandler', class: CustomPageHandler, id: 'lookbooks-en' },
			{ name: 'gdprEnPageHandler', class: CustomPageHandler, id: 'gdpr-en' },
			{ name: 'termsofuseEnPageHandler', class: CustomPageHandler, id: 'terms-of-use-en' },
			{ name: 'privacyEnPageHandler', class: CustomPageHandler, id: 'privacy-policy-en' },
			{ name: 'cookiesEnPageHandler', class: CustomPageHandler, id: 'cookies-en' },
			{ name: 'successEnPageHandler', class: CustomPageHandler, id: 'success-en' },
			{ name: 'unsubscribedEnPageHandler', class: CustomPageHandler, id: 'unsubscribed-en' },
			{ name: 'thank-youEnPageHandler', class: CustomPageHandler, id: 'thank-you-en' },
			{ name: 'manage-subscriptionEnPageHandler', class: CustomPageHandler, id: 'manage-subscription-en' },
		];
		this.objectHandlers = [
			{ name: 'primaryMenuHandler', class: MenuHandler, id: 'primary-menu' },
		];
	}

	getPageHandler(id) {
		var handler = this.pageHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	getObjectHandler(id) {
		var handler = this.objectHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	initHandlers() {
		this.pageHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
		this.objectHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
	}

	closeMobMenu() {

	}

	events() {
		jQuery(`.main-navigation li a[target!='_blank'], 
			button a[target!='_blank'], 
			.polylang_langswitcher a[target!='_blank'],
			footer li a[target!='_blank'], 
			.site-branding a[target!='_blank'], 
			#blog article a[target!='_blank'], 
			.popup-section-in a[target!='_blank'],
			#mob-primary-menu a[target!='_blank']`).on('click', function(e) {
				console.log(e.target.href);
			e.stopPropagation();
			e.preventDefault();
			window.leaving = true;
			if (!e.target.href)
				ajaxPH.maskOn('/');
			else
				ajaxPH.maskOn(e.target.href);

		})
		jQuery('.go-to-top').on('click', function() {
			gsap.to(smoother, {scrollTop: 0, ease: "expo", duration: 1.2});
		})
		jQuery('.main-navigation__lines').on('click', function () {
			var me = jQuery(this);
			var openClass = 'main-navigation__lines--open';
			me.toggleClass(openClass);
			jQuery("#masthead").toggleClass('header--open')
			if (me.hasClass(openClass)) {
				gsap.to('.mob-menu-overlay', {
					duration: 0.3,
					autoAlpha: 1,
					ease: 'power1.inOut'
				});
				window.smoother.paused(true);
			} else {
				gsap.to('.mob-menu-overlay', {
					duration: 0.3,
					autoAlpha: 0,
					ease: 'power1.inOut'
				});
				window.smoother.paused(false);

			}
		});
	}

	init() {
		this.initHandlers();
		this.events();
		
		jQuery('a[href^="#"]').on('click', function(e) {
			e.preventDefault();
		})
	}

	destroy() {

	}

	transitions () {
		
	}
}

window.addEventListener('beforeunload', function (e) {
	// if (!window.leaving)
	// 	ajaxPH.maskOn();
	
}, false);

(function($) {
	$(function() {
		window.global = new GlobalHandler();
		window.global.init();

		window.utils = new Utils();

		window.ajaxPH = new AjaxPageHandler();
		ajaxPH.init();

		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
		gsap.registerPlugin(ScrollSmoother)

		
		const main = document.querySelector('main');
		if (main && window.global.getPageHandler(main.id)) {
			window.global.getPageHandler(main.id).init();
		}

		ajaxPH.maskOff(() => {
			if (main && window.global.getPageHandler(main.id)) {
				window.global.getPageHandler(main.id).transitions();
			}
		});

		window.global.getObjectHandler('primary-menu').init();
		let mm = gsap.matchMedia();

		// // create the smooth scroller FIRST!
		// window.smoother = ScrollSmoother.create({
		// 	smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
		// 	effects: true
		// });

		// ScrollTrigger.normalizeScroll(true);
		window.largeFirst = (window.innerWidth >= 800);
		mm.add("(min-width: 800px)", () => {
			if (!window.largeFirst)
				window.location.reload();
		})
		mm.add("(max-width: 799px)", () => {
			if (window.largeFirst)
				window.location.reload();
			// ScrollTrigger.normalizeScroll(false);
			ScrollTrigger.update();
			ScrollTrigger.refresh();
		})

		document.addEventListener('visibilitychange', function() {
			if (document.visibilityState === 'visible' && window.leaving) {
				ajaxPH.maskOff(() => {
					// var openClass = "main-navigation__lines--open";
					// if (jQuery('.main-navigation__lines').hasClass(openClass)) {
					// 	jQuery('.main-navigation__lines').removeClass(openClass);
					// 	gsap.set('body, html', {overflow: "unset", height: 'auto'})
					// 	gsap.to('.mob-menu-overlay', {
					// 		duration: 0.3,
					// 		autoAlpha: 0,
					// 		ease: 'power1.inOut'
					// 	});
					// 	gsap.to('.header-social-media', {
					// 		autoAlpha: 0,
					// 		duration: 0.3,
					// 		ease: 'power1.inOut'
					// 	})
					// }
				});
			}
		});

		SmoothScroll({ 
			animationTime    : 600, // [ms]
			stepSize         : 100, // [px]
		
			// Acceleration
			accelerationDelta : 60,  // 50
			accelerationMax   : 3,   // 3
		})
			
	})
}(jQuery));